import { dropLast, flat, map, pipe, zip } from 'remeda';
import type { LightUser } from 'shared/hooks/use-load-light-users';
import type { Id } from 'types';
import type { DescVal } from 'types/storeTypes';

export * from './charts';
export * from './currency';
export * from './date';
export * from './environment';
export * from './feature-flags';
export * from './form';
export * from './identities';
export * from './invoice-status';
export * from './mask.utils';
export * from './payment';
export * from './query';
export * from './table';
export * from './unimplemented';

export function usersToDescVal(users: Array<LightUser>): Array<DescVal<Id>> {
  return users.map(({ id, name }) => ({ description: name.full, value: id }));
}

export function extractNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function fixUtf8StringEncoding(str: string) {
  try {
    return decodeURIComponent(escape(str));
  } catch {
    return str;
  }
}

export function assert(condition: any, message?: string): asserts condition {
  if (!condition) throw new Error(message || 'Assertion failed');
}

export function intersperse<T, S>(array: readonly T[], separator: S): Array<T | S>;
export function intersperse<T, S>(array: readonly T[], separator: () => S): Array<T | S>;
export function intersperse<T, S>(array: readonly T[], separator: S | (() => S)): Array<T | S> {
  if (array.length === 0) return [];
  if (array.length === 1) return [...array];

  const getSep: () => S =
    typeof separator === 'function' ? (separator as () => S) : () => separator;

  const glue = pipe(array, map(getSep), dropLast(1));

  return flat(zip(array, glue));
}
